import { makeAutoObservable, observable, values } from 'mobx'
import { RootStore } from '../RootStore'
import { CustomFont, ICustomFont } from './CustomFont'
import { sendToApi } from 'api/client'
import { Font } from 'types'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'

export class CustomFontsStore {
  rootStore: RootStore
  ready = false
  private _fonts = observable.map<ICustomFont['name'], CustomFont>()

  constructor(rootStore: RootStore) {
    makeAutoObservable(this)

    this.rootStore = rootStore
  }

  load = (key: ICustomFont['name']) => {
    const font = this._fonts.get(key)
    if (!font) {
      return
    }

    return font.load()
  }

  get = (key: ICustomFont['name']) => {
    return this._fonts.get(key)
  }

  get list() {
    return values(this._fonts)
  }

  addBulk = (items: ICustomFont[], workspaceId: number) => {
    items.forEach((item: ICustomFont) => {
      this._fonts.set(item.name, new CustomFont(item, workspaceId))
    })
  }

  getByLoadingState = (...states: Array<CustomFont['loadingState']>) => {
    return this.list.filter((font) => states.includes(font.loadingState))
  }

  fetchAll = async (workspaceId: number) => {
    this._fonts.clear()
    try {
      const res = await sendToApi<{ fonts: Font[] }>(`/w/${workspaceId}/fonts`)
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error('Failed to fetch fonts')
      }

      this.addBulk(res.data.fonts, workspaceId)
      this.ready = true
    } catch (error) {}
  }
}
